import styled from 'styled-components';
import { AppStyledProps } from '../../../../../types';

type T = AppStyledProps;

export const ButtonGroupStyled = styled.div<T>`
  font-size: 1em;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  & > button {
    margin-right: 0.4em;
  }
`;
